import React, { useEffect, useState } from "react";
import styles from "./Home.module.css";
import Card from "../Card/Card";
import SideIcons from "../SideIcons/SideIcons";
import TechStacks from "../TechStacks/TechStacks";
import AOS from "aos";
import "aos/dist/aos.css";

import { Button } from "../Button/Button";
import About from "../About/About";
import { projects } from "../../Utils/Projects";
import Contact from "../Contact/Contact";
import { ThemeContext } from "../../ContextProvider/ThemeContext";
import Education from "../Education/Education";
import Experiences from "../Experiences/Experiences";

const Home = ({ scrollRef }) => {
  const [projectArray, setProjectArray] = useState(projects.slice(0, 4));
  const { newTheme } = React.useContext(ThemeContext);
  const [offset, setOffset] = useState(0);
  // const [location, setLocation] = useState(0);
  useEffect(() => {
    AOS.init();
  });

  const handleOffset = () => {
    setOffset(window.pageYOffset);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleOffset);
    return () => window.removeEventListener("scroll", handleOffset);
  }, []);

  useEffect(() => {
    document.body.style.backgroundColor = newTheme.background;
  }, [newTheme]);

  const handleButton = () => {};

  console.log(offset);
  // const handleShowMoreBtn = () => {
  // 	if (projects.length === projectArray.length) {
  // 		setProjectArray(projects.slice(0, 4));
  // 		window.scrollTo(0, location);
  // 	} else {
  // 		setProjectArray(projects);
  // 		setLocation(offset)
  // 	}
  // };

  return (
    <div ref={scrollRef}>
      <SideIcons />
      <div
        id="home"
        className={styles.profile}
        style={{ backgroundColor: `${newTheme.imgBackground}` }}
      >
        <div
          data-aos="fade-zoom-out"
          className={styles.intro}
          style={{
            color: `${newTheme.para}`,
            transform: `translateX(-${offset * 2.5}px)`,
            opacity: `${offset > 300 ? "0" : offset > 160 ? ".5" : "1"}`,
          }}
        >
          <h1>
            <span>Hi, My name is</span>
            <div className={styles.name} style={{ color: `${newTheme.title}` }}>
              Kirankumar J Meshram
            </div>
          </h1>
          <h1>
            A Full-Stack Web Developer specializing in the MERN stack, committed
            to writing clean, efficient, and scalable code. Proficient in HTML,
            JavaScript, CSS, and Node.js, I focus on delivering high-performance
            web solutions. Passionate about enhancing user experiences through
            elegant design and innovative technology.
          </h1>
          <div className={styles.btn}>
            <a
              href="https://drive.google.com/uc?export=download&id=1dy32-G-YXbK0oK5VsxRkrXf-iqzFKzqP" 
              target="blank"
              download="Kirankumar_Resume.pdf"
            >
              <Button
                text={
                  <span className={styles.resumeBtn}>
                    <span>Resume</span> <i className="fas fa-file-download"></i>
                  </span>
                }
                handleButton={handleButton}
              />
            </a>
          </div>
        </div>

        <div
          style={{
            transform: `translateX(${offset * 2.5}px)`,
            opacity: `${offset > 300 ? "0" : offset > 160 ? ".5" : "1"}`,
          }}
          className={styles.profileImage}
        >
          <img src="https://lh3.googleusercontent.com/pw/AP1GczN93D68Qz0iv6-W1sxt1cfda-I-cCuResVjcGfo-hbye-bvEGTnefYdd1aBjJP7E9W08pdb4zRJ5jSoLo7ko8B4wBIvs9crzgYfjcNgD-aYBmBL0mCyjCN6VFB29pQIKaUfTfnpRRqwOPiypngvuFsXOw=w780-h890-s-no-gm" alt="profile_img"/>
        </div>
      </div>

      <div
        id="about"
        style={{
          background: `${newTheme.highlightBackground}`,
        }}
        className={styles.experience}
      >
        <About />
      </div>

      <div id="techStacks" className={styles.techStacks}>
        <TechStacks />
      </div>

      <div
        id="experience"
        className={styles.experience}
        style={{
          background: `${newTheme.highlightBackground}`,
        }}
      >
        <div
          data-aos="fade-right"
          data-aos-offset="150"
          data-aos-easing="ease-in-sine"
          data-aos-duration="700"
          style={{ color: `${newTheme.para}` }}
        >
          <Experiences />
        </div>
      </div>

      <div
        id="education"
        className={styles.experience}
        style={{
          background: `${newTheme.highlightBackground}`,
        }}
      >
        <div
          data-aos="fade-right"
          data-aos-offset="150"
          data-aos-easing="ease-in-sine"
          data-aos-duration="700"
          style={{ color: `${newTheme.para}` }}
        >
          <Education />
        </div>
      </div>

      {/* project section from here => */}
      <div id="projects" className={styles.projects}>
        <h1 style={{ color: `${newTheme.title}` }} className={styles.heading}>
          Things I've Developed
        </h1>
        <div className={styles.borderBottom} />
        <div>
          {projectArray.map((item, index) => (
            <Card key={index} {...item} />
          ))}
        </div>
        {/* <Button
					text={
						projects.length == 3
							? 'Show More'
							: 'Show Less'
					}
					handleButton={handleShowMoreBtn}
				/> */}
      </div>
      <div
        style={{
          background: `${newTheme.highlightBackground}`,
        }}
      >
        <Contact />
      </div>
    </div>
  );
};

export default Home;
